import styled from 'styled-components'

import Media from 'builder/styles/media'
import Colors from 'builder/styles/colors'
import { Icon20 } from 'builder/components/Icon'
import { isSafari } from 'builder/features/navigation/utils'
import Typography, { FontWeights } from 'builder/styles/typography'

export const InfoSection = styled.div`
  width: inherit;
  display: flex;
  align-items: center;
  margin-top: auto;
  margin-bottom: 28px;
  z-index: 1;
  padding: 8px 0;

  ${Media.Phone`
    width: 100%;
    position: fixed;
    bottom: ${isSafari() ? '80px' : '70px'};
    margin-bottom: 0;
    background-color: ${Colors.White};
    justify-content: center;
  `}
`

export const InfoSectionIcon = styled(Icon20.Time)`
  margin-top: -2px;
  margin-right: 2px;
  fill: white;
  color: ${Colors.Neutral50};
`

export const InfoSectionDescription = styled.div`
  color: ${Colors.Neutral50};
  ${Typography.Caption}
  ${FontWeights.Regular}
`

export const InfoSectionDescriptionBold = styled.span`
  color: ${Colors.Neutral90};
  ${Typography.Caption}
  ${FontWeights.Medium}
`
